module.exports = __webpack_public_path__ + "img/mark.825938f.webp";